<h1 mat-dialog-title>Cart &mdash; {{ cart.email }} &mdash; {{ cart.id }}</h1>

<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Dettagli"
      ><app-cart-data-renderer [cart]="cart"></app-cart-data-renderer
    ></mat-tab>
    <mat-tab label="Form 1"
      ><app-typeform-response-renderer
        *ngIf="cart.typeform1?.data"
        [response]="cart.typeform1.data"
      ></app-typeform-response-renderer
    ></mat-tab>
    <mat-tab label="Form 2"
      ><app-typeform-response-renderer
        *ngIf="cart.typeform2?.data"
        [response]="cart.typeform2.data"
      ></app-typeform-response-renderer
    ></mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button mat-raised-button color="primary" (click)="close()" cdkFocusInitial>
    Ok
  </button>
</div>
